export default "__VITE_ASSET__BAaxvTeD__"